import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, Star, ArrowLeft, ArrowRight } from "lucide-react";
import { TESTIMONIALS } from "../lib/content";
import { Reveal } from "./Reveal";

export const Testimonials = () => {
  const [i, setI] = useState(0);
  const t = TESTIMONIALS[i];
  const go = (d) => setI((p) => (p + d + TESTIMONIALS.length) % TESTIMONIALS.length);

  return (
    <section data-testid="testimonials" className="relative bg-dst-navy py-24 lg:py-36 overflow-hidden grain">
      <div className="container-dst relative z-10">
        <Reveal className="flex items-end justify-between flex-wrap gap-6 mb-16">
          <div>
            <span className="eyebrow text-dst-red">What they're saying</span>
            <h2 className="mt-4 font-oswald font-700 uppercase tracking-tighter leading-[0.9] text-5xl lg:text-7xl">
              Trusted By<br />Competitors
            </h2>
          </div>
          <div className="flex gap-3">
            <button data-testid="testimonial-prev" onClick={() => go(-1)} className="w-14 h-14 grid place-items-center border border-white/20 text-white hover:bg-dst-red hover:border-dst-red transition-colors">
              <ArrowLeft size={20} />
            </button>
            <button data-testid="testimonial-next" onClick={() => go(1)} className="w-14 h-14 grid place-items-center border border-white/20 text-white hover:bg-dst-red hover:border-dst-red transition-colors">
              <ArrowRight size={20} />
            </button>
          </div>
        </Reveal>

        <Quote size={120} className="text-dst-red/30 absolute -top-2 left-6 -z-0" />
        <div className="relative min-h-[280px]">
          <AnimatePresence mode="wait">
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.5 }}
              data-testid="testimonial-card"
            >
              <div className="flex gap-1 mb-6">
                {Array.from({ length: t.rating }).map((_, s) => (
                  <Star key={s} size={22} className="fill-dst-red text-dst-red" />
                ))}
              </div>
              <p className="font-oswald font-500 text-3xl sm:text-4xl lg:text-5xl leading-[1.15] tracking-tight max-w-5xl">
                "{t.quote}"
              </p>
              <div className="mt-10 flex items-center gap-4">
                <div className="w-12 h-0.5 bg-dst-red" />
                <div>
                  <div className="font-oswald uppercase text-lg tracking-wide">{t.name}</div>
                  <div className="text-white/50 text-sm">{t.role}</div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="flex gap-2 mt-12">
          {TESTIMONIALS.map((_, d) => (
            <button
              key={d}
              onClick={() => setI(d)}
              className={`h-1 transition-all duration-300 ${d === i ? "w-12 bg-dst-red" : "w-6 bg-white/20"}`}
              aria-label={`Go to testimonial ${d + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
